import React, { Component } from 'react';
import successLogo from './../../../../../statics/img/spotii/success.svg';
import failLogo from './../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../statics/img/esaypaisa/pending.svg';
import './Spotii.css';

class JazzCashStatus extends Component {
    
    componentDidMount (){
        setTimeout(()=>{
            if(this.props.status_message == "Transaction abandoned."){
                window.history.back();
            }else{
                window.location.href = this.props.redirection_url;
            }
            
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4>Transaction Successful.</h4>
            <p>Payment successfully confirmed, page will be redirected to the merchant's website.</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4>Payment failed</h4>
            <p>{this.props.status_message != "" ? this.props.status_message : "Insufficient funds."}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4>Payment pending</h4>
            <p>Thank you for using Spotii.</p>
            <p>Your payment is being processed.</p>
        </div>
    )

    render() {
        return (
            <div className="spotii_content spotii_status">
                {this.props.spotii_status == "success" && this.renderSuccess()}
                {this.props.spotii_status == "fail" && this.renderFail()}
                {this.props.spotii_status == "pending" && this.renderPending()}
            </div>
        )
    }
}
export default JazzCashStatus;